<template>
  <div class="app-container">
    <a-card>
      <!-- 搜索表单 -->
      <a-form layout="inline">
        <a-form-item label="栏目名称：">
          <a-input
              v-model="queryParams.categoryName"
              placeholder="请输入栏目名称"
              allow-clear
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSearch">搜索</a-button>
        </a-form-item>
      </a-form>

      <!-- 新增按钮 -->
      <div style="margin: 16px 0;">
        <a-button type="primary" @click="handleAdd">+ 新增栏目</a-button>
      </div>

      <!-- 列表表格 -->
      <a-table
          :columns="columns"
          :dataSource="list"
          :pagination="pagination"
          @change="handleTableChange"
          rowKey="id"
          bordered
      />
    </a-card>
  </div>
</template>

<script>
import { message, Modal } from 'ant-design-vue';
import { getCategoryPage, updateCategorySort, updateCategoryStatus, deleteCategory } from '@/api/category/category';

export default {
  name: 'PlatformCategory',
  data() {
    return {
      queryParams: {
        categoryName: '',
        pageNum: 1,
        pageSize: 10,
      },
      list: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条`,
      },
      columns: [
        { title: 'ID', dataIndex: 'id', key: 'id' },
        { title: '栏目名称', dataIndex: 'categoryName', key: 'categoryName' },
        { title: '剧集数', dataIndex: 'videoCount', key: 'videoCount' },
        {
          title: '排序(回车或失焦保存)',
          dataIndex: 'categorySort',
          key: 'categorySort',
          customRender: (text, record) => {
            return (
                <a-input-number
                    value={record.categorySort}
                    min={1}
                    precision={0}
                    style="width: 80px;"
                    onChange={value => { record.categorySort = value; }}
                    onPressEnter={() => this.handleSortSave(record)}
                    onBlur={() => this.handleSortSave(record)}
                />
            );
          },
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          customRender: text => text === 1 ? '启用' : '禁用',
        },
        {
          title: '操作',
          key: 'action',
          customRender: (text, record) => {
            return (
                <span>
                  <a onClick={() => this.handleToggleStatus(record)}>
                  {record.status === 1 ? '禁用' : '启用'}
                </a>
                  <a-divider type="vertical"/>
                <a onClick={() => this.handleEdit(record)}>编辑</a>
                <a-divider type="vertical"/>
                <a onClick={() => this.handleDelete(record)}>删除</a>
              </span>
            );
          },
        },
      ],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      getCategoryPage(this.queryParams).then(res => {
        if (res.success && res.data) {
          this.list = res.data.records || [];
          this.pagination.total = res.data.total || res.data.records.length;
          this.pagination.current = res.data.current || 1;
        } else {
          this.list = [];
          this.pagination.total = 0;
        }
      });
    },
    handleSearch() {
      this.queryParams.pageNum = 1;
      this.fetchData();
    },
    handleSortSave(record) {
      const params = {
        id: record.id,
        categorySort: record.categorySort,
      };
      updateCategorySort(params).then(res => {
        if (res.success) {
          message.success('排序更新成功');
          this.fetchData();
        } else {
          message.error(res.message || '排序更新失败');
        }
      }).catch(() => {
        message.error('请求失败，请稍后重试');
      });
    },
    handleTableChange(pagination) {
      this.queryParams.pageNum = pagination.current;
      this.queryParams.pageSize = pagination.pageSize;
      this.fetchData();
    },
    handleAdd() {
      this.$router.push('/category/add');
    },
    handleEdit(record) {
      this.$router.push(`/category/edit/${record.id}`);
    },
    handleDelete(record) {
      Modal.confirm({
        title: '确认删除',
        content: `确定要删除栏目 "${record.categoryName}" 吗？此操作不可恢复。`,
        okText: '确认删除',
        cancelText: '取消',
        onOk: () => {
          return deleteCategory({ id: record.id }).then(res => {
            if (res.success) {
              message.success('删除成功');
              this.fetchData();
            } else {
              message.error(res.message || '删除失败');
            }
          }).catch(() => {
            message.error('请求失败，请稍后重试');
          });
        }
      });
    },
    handleToggleStatus(record) {
      const newStatus = record.status === 1 ? 0 : 1;
      updateCategoryStatus({id: record.id, status: newStatus}).then(res => {
        if (res.success) {
          message.success(`${newStatus === 1 ? '启用' : '禁用'}成功`);
          this.fetchData();
        } else {
          message.error(res.message || `${newStatus === 1 ? '启用' : '禁用'}失败`);
        }
      }).catch(() => {
        message.error('请求失败，请稍后重试');
      });
    },
  },
};
</script>

<style scoped>
.app-container {
  background: #fff;
  padding: 24px;
}
</style>
